import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getForfaitsTransport = async () => {
    const forfaitsTransport = await axios.get('/service/forfaitsTransport')
    .catch((e) => {
        throw new CustomException(e, 'Error fetching forfaits transport')
    })
    return forfaitsTransport.data
}

export const postForfaitTransport = async forfait => {
    const forfaitRemote = await axios.post('/service/forfaitTransport', forfait)
    .catch((e) => {
        throw new CustomException(e, 'Error posting forfaitTransport')
    })
    return forfaitRemote.data
}

export const deleteForfaitTransport = async id => {
    const forfait = await axios.delete(`/service/forfaitTransport/${id}`)
    .catch((e) => {
        throw new CustomException(e, 'Error deleting forfaitTransport')
    })
    Vue.toasted.show('Forfait supprimé').goAway(1500)
    return forfait.data
}

export const resetForfaitTransport = async () => {
  const forfaitsTransport = await axios.delete('/service/resetForfaitTransport')
    .catch((e) => {
      throw new CustomException(e, 'Error deleting forfaits')
    })
  return forfaitsTransport.data
}
